import kuromoji from 'kuromoji';

let _tokenizer = null;
let _initPromise = null;

export function initTokenizer() {
  if (_tokenizer) return Promise.resolve(_tokenizer);
  if (_initPromise) return _initPromise;
  _initPromise = new Promise((resolve, reject) => {
    kuromoji.builder({ dicPath: '/dict' }).build((err, t) => {
      if (err) { reject(err); return; }
      _tokenizer = t;
      resolve(t);
    });
  });
  return _initPromise;
}

export function tokenize(text) {
  return _tokenizer.tokenize(text);
}
